import {Button, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import {PlanTypeEnum} from 'presentation/constants';
import {planTypeOptions} from 'presentation/pages/others';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {BeneficiarySummaryCardProps} from './types';
import {TagChip} from '../TagChip';

const {change} = translations['pt-br'].commons;

function BeneficiarySummaryCard({
	disableGuters,
	handleAction,
	hideAction,
	beneficiaryName,
	planName,
	planType,
	isRebooking,
}: BeneficiarySummaryCardProps) {
	const {colors} = useTheme();
	const beneficiaryCardPlanData = {
		planName,
		userName: formatText(beneficiaryName),
		chipColor: planTypeOptions[planType.toUpperCase() as PlanTypeEnum].color,
		chipLabel: planTypeOptions[planType.toUpperCase() as PlanTypeEnum].label,
	};

	return (
		<Stack p={2} pb={2.5} px={disableGuters ? 0 : 2}>
			<Stack flexDirection="row" justifyContent="space-between" alignItems="center" mb={0.5}>
				<Typography variant="body1">{beneficiaryCardPlanData.userName}</Typography>
				{!isRebooking && !hideAction ? (
					<Button variant="text" size="small" onClick={handleAction}>
						{change}
					</Button>
				) : null}
			</Stack>
			<Typography variant="body2">{beneficiaryCardPlanData.planName}</Typography>
			<TagChip
				label={beneficiaryCardPlanData.chipLabel}
				color={beneficiaryCardPlanData.chipColor}
				bgColor={
					planType === PlanTypeEnum.HEALTH ? colors.light.primary['30Percent'] : undefined
				}
				sx={{alignSelf: 'flex-start', mt: 1}}
			/>
		</Stack>
	);
}

export {BeneficiarySummaryCard};
